module.exports = __webpack_public_path__ + "static/bbis-hero-pool-6de2ffc4ff9de189d79c4b9c353ab389.jpg";